module.exports = __webpack_public_path__ + "static/media/live12_09_2023.746eb0a9.jpg";